import React, { PureComponent } from 'react';

import { Settings as SettingsIcon, Save as ActionSave } from '@mui/icons-material';

import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  TextField,
  Switch,
  IconButton,
  Tooltip,
  Zoom,
  MenuItem,
} from '@mui/material';

import Tile from '../../../../common/components/Tile/Tile';
import PermissionsCheck from '../../../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../../../common/constants/PermissionsEnum';
import './SystemSettings.css';

class SystemSettings extends PureComponent {
  render() {
    return (
      <Tile title="System settings" TitleIcon={SettingsIcon} helpTag="system_settings">
        <Table className="system-settings-table" data-qa="qa-system_settings">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: '5%' }}>No</TableCell>
              <TableCell style={{ width: '20%' }}>Setting key</TableCell>
              <TableCell style={{ width: '20%' }}>Setting value</TableCell>
              <TableCell style={{ width: '40%' }}>Description</TableCell>
              <TableCell style={{ width: '10%', whiteSpace: 'normal' }}>
                Is server setting
              </TableCell>
              <TableCell style={{ width: '10%' }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.data
              ? this.props.data.map((s, i) => (
                  <TableRow key={s.SystemSettingId}>
                    <TableCell style={{ width: '5%' }}>{i + 1}</TableCell>
                    <TableCell style={{ width: '20%' }}>{s.Key}</TableCell>
                    <TableCell style={{ width: '30%', minWidth: '10rem' }}>
                      <PermissionsCheck permission={PermissionsEnum.EDIT_SYSTEM_SETTINGS}>
                        {this.props.config.find((el) => el.Key == s.Key && el.Type == 'dropdown') !=
                        undefined ? (
                          <TextField
                            variant="standard"
                            select={true}
                            value={s.Value}
                            onChange={(event) =>
                              this.props.handleChangeFor('Value', event.target.value, s, i)
                            }
                            data-qa="qa-value-select-dropdown"
                            style={{ width: '100%' }}
                            margin="normal"
                          >
                            {this.props.config
                              .find((el) => el.Key == s.Key)
                              .Values.map((config) => (
                                <MenuItem key={config + i} value={config}>
                                  {`${config}`}
                                </MenuItem>
                              ))}
                          </TextField>
                        ) : (
                          <TextField
                            variant="standard"
                            placeholder="Value"
                            value={s.Value}
                            multiline
                            minRows={1}
                            maxRows={5}
                            onChange={(e) =>
                              this.props.handleChangeFor('Value', e.target.value, s, i)
                            }
                            data-qa="qa-value-select-dropdown"
                            style={{ width: '100%' }}
                          />
                        )}
                      </PermissionsCheck>
                      <PermissionsCheck
                        permission={PermissionsEnum.EDIT_SYSTEM_SETTINGS}
                        hasPermission={false}
                      >
                        <span>{s.Value}</span>
                      </PermissionsCheck>
                    </TableCell>
                    <TableCell style={{ width: '35%', minWidth: '10rem' }}>
                      <PermissionsCheck permission={PermissionsEnum.EDIT_SYSTEM_SETTINGS}>
                        <TextField
                          variant="standard"
                          placeholder="Description"
                          value={s.Description}
                          multiline
                          minRows={1}
                          maxRows={5}
                          onChange={(e) =>
                            this.props.handleChangeFor('Description', e.target.value, s, i)
                          }
                          data-qa="qa-setting-description"
                          style={{ width: '100%' }}
                        />
                      </PermissionsCheck>
                      <PermissionsCheck
                        permission={PermissionsEnum.EDIT_SYSTEM_SETTINGS}
                        hasPermission={false}
                      >
                        <span>{s.Description}</span>
                      </PermissionsCheck>
                    </TableCell>
                    <TableCell style={{ width: '10%' }}>
                      <Switch
                        color="secondary"
                        checked={!s.IsUsedByDashboard}
                        disabled={true}
                        onChange={(e) =>
                          this.props.handleChangeFor('IsUsedByDashboard', e.target.checked, s, i)
                        }
                        data-qa="qa-used-by-dashboard-switch"
                      />
                    </TableCell>
                    <TableCell style={{ width: '5%' }}>
                      {s.hasChanges && s.Value ? (
                        <Tooltip disableInteractive TransitionComponent={Zoom} title="Save">
                          <IconButton
                            size="large"
                            style={{}}
                            onClick={(e) => this.props.onClickSave(s, i)}
                            data-qa="qa-saveicon"
                          >
                            <ActionSave />
                          </IconButton>
                        </Tooltip>
                      ) : null}
                    </TableCell>
                  </TableRow>
                ))
              : null}
          </TableBody>
        </Table>
      </Tile>
    );
  }
}

export default SystemSettings;
